import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { MAPPINGS_MODE, MAPPINGS_SCALE } from './Switch.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const SwitchLabel = styled.label `
  ${({ scale, theme }) => {
    const { fontSize, fontWeight } = MAPPINGS_SCALE[scale];
    return css `
      align-items: center;
      cursor: pointer;
      display: inline-flex;
      font-family: ${theme.typography.fontFamily};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      gap: ${getSpace('s')};
      line-height: ${tokens.font.lineHeight.text.value};
    `;
}}
`;
export const SwitchRoot = styled.input.attrs({ type: 'checkbox' }) `
  ${({ mode }) => {
    const { background, border, checked, disabled, dot, focus, hover } = MAPPINGS_MODE[mode];
    return css `
      appearance: none;
      border-radius: 9999px;
      cursor: pointer;
      display: inline-block;
      flex: 1 0 auto;
      height: 2rem;
      max-width: 3.5rem;
      outline: none;
      position: relative;
      transition: 0.3s;
      vertical-align: top;
      width: 3.5rem;

      /* Color */
      background: ${background};
      border: 2px solid ${border};

      &::after {
        border-radius: 50%;
        content: '';
        display: block;
        height: 1.25rem;
        left: 3px;
        position: absolute;
        top: 4px;
        transform: translateX(0);
        transition: 0.3s;
        width: 1.25rem;

        /* Color */
        background-color: ${dot};
      }

      /* Error */
      &.error {
        border-color: ${tokens.colors.red[700].value};

        &::after {
          background-color: ${tokens.colors.red[700].value};
        }
      }

      /* Disabled */
      &[disabled] {
        background-color: ${disabled.background};
        border-color: ${disabled.border};
        pointer-events: none;

        &::after {
          background-color: ${disabled.dot};
        }

        &:checked {
          background-color: ${disabled.checked};
        }
      }

      /* Focus */
      &:focus {
        background-color: ${focus.background};
        box-shadow: 0 0 0 4px ${focus.shadow};
        outline: 0;

        &:checked {
          background-color: ${focus.checkedBackground};
          border-color: ${focus.checkerBorder};
        }
      }

      /* Hover */
      &:hover {
        border-color: ${hover.border};

        &::after {
          background-color: ${hover.dot};
        }
      }

      /* Checked. */
      &:checked {
        background: ${checked.background};
        border-color: ${checked.border};

        &::after {
          background-color: ${checked.dot};
          transform: translateX(24px);
        }

        &:hover {
          background-color: ${checked.hoverBackground};
          border-color: ${checked.hoverBorder};

          &::after {
            background-color: ${checked.hoverDot};
          }
        }
      }
    `;
}}
`;
export const SwitchWrapper = styled.div `
  align-items: center;
  display: inline-flex;
  gap: 0.5rem;
`;
//# sourceMappingURL=Switch.styled.js.map